// Return "YYYY-MM-DD" from Date | string | number | null
export const toSqlDate = (v) => {
  if (!v) return null;
  if (typeof v === "string") {
    // Already a plain date? Return it trimmed.
    if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v.slice(0, 10);
    // ISO string or other -> normalize via Date
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return null;
    return d.toISOString().slice(0, 10);
  }
  if (v instanceof Date) {
    if (Number.isNaN(v.getTime())) return null;
    return v.toISOString().slice(0, 10);
  }
  if (typeof v === "number") {
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return null;
    return d.toISOString().slice(0, 10);
  }
  return null;
};

// Make a Date object representing the given SQL date at midnight **UTC**
// This avoids local timezone/DST shifts when you only care about the calendar date.
export const fromSqlDateUTC = (s) => {
  if (!s) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s.trim());
  if (!m) return null;
  const [ , y, mo, d ] = m;
  return new Date(Date.UTC(+y, +mo - 1, +d, 0, 0, 0));
};

// Compare two date-only values for same calendar day
export const sameSqlDate = (a, b) => {
  const A = toSqlDate(a);
  const B = toSqlDate(b);
  return !!A && !!B && A === B;
};

// Backwards compatible aliases (so existing imports don't break)
export const fmtDate = toSqlDate;
export const parseSqlDate = fromSqlDateUTC;

// Return "YYYY-MM-DD" using *local* calendar date (no UTC shift).
// Use this for values coming from DatePickers where the user picked a calendar date.
export const toSqlDateLocal = (v) => {
  if (!v) return null;

  if (typeof v === "string") {
    // Already a plain date? Return it trimmed.
    if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v.slice(0, 10);
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return null;
    // fall through to local formatting
    v = d;
  }

  if (typeof v === "number") {
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return null;
    v = d;
  }

  if (v instanceof Date) {
    if (Number.isNaN(v.getTime())) return null;
    const yyyy = v.getFullYear();
    const mm = String(v.getMonth() + 1).padStart(2, "0");
    const dd = String(v.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  }

  return null;
};

// Optional: local version of sameSqlDate (useful for transfer matching)
export const sameSqlDateLocal = (a, b) => {
  const A = toSqlDateLocal(a);
  const B = toSqlDateLocal(b);
  return !!A && !!B && A === B;
};

// Normalise time strings for LocalTime ("HH:mm:ss")
export const toSqlTime = (t) => {
  if (!t) return null;
  const s = String(t).trim();
  if (!s) return null;
  if (/^\d{2}:\d{2}$/.test(s)) return `${s}:00`;
  if (/^\d{2}:\d{2}:\d{2}$/.test(s)) return s;
  return null;
};

